<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2>华魏WMS 登录</h2>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="form.password" placeholder="请输入密码" />
        </el-form-item>
        <el-form-item label="验证码" prop="captcha">
          <div style="display: flex; gap: 10px;">
            <el-input v-model="form.captcha" placeholder="请输入验证码" style="flex:1" />
            <img :src="captchaImage" @click="refreshCaptcha" style="width: 100px; height: 36px; cursor: pointer;" />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login, getCaptcha } from '@/api/auth'
import { getMenuTree } from '@/api/menu'

export default {
  name: 'LoginLogin',
  data() {
    return {
      form: { username: '', password: '', captcha: '', captchaKey: '' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loading: false,
      captchaImage: ''
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    async refreshCaptcha() {
      const res = await getCaptcha()
      this.captchaImage = res.image
      this.form.captchaKey = res.key
    },
    async handleLogin() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const res = await login(this.form)
          localStorage.setItem('token', res.token)
          localStorage.setItem('username', this.form.username)
          localStorage.setItem('factories', JSON.stringify(res.factories || [res.currentFactory]))
          localStorage.setItem('currentFactory', res.currentFactory)
          localStorage.setItem('erpType', res.erpType || 'NONE')
          localStorage.setItem('sysConnection', res.sysConnection || 'ONLY_WMS')   // A-1.2：连接模式
          // 存储权限码列表（按钮级权限控制）
          if (res.permissions) {
            localStorage.setItem('permissions', JSON.stringify(res.permissions))
          }
          if (res.roles) {
            localStorage.setItem('roles', JSON.stringify(res.roles))
          }

          if (res.defaultWarehouseId) {
            localStorage.setItem('currentWarehouseId', String(res.defaultWarehouseId))
          }

          const menuTree = await getMenuTree()
          localStorage.setItem('menuTree', JSON.stringify(menuTree))


          window.location.href = '/workbench'
          this.$message.success('登录成功')
        } catch (err) {
          this.$message.error(err.message || '登录失败')
          this.refreshCaptcha() // 刷新验证码
        } finally {
          this.loading = false
        }
      })
    },
    findFirstValidMenu(menus) {
      for (const menu of menus) {
        if (menu.component && menu.path && menu.path !== '#') {
          return menu
        }
        if (menu.children && menu.children.length) {
          const found = this.findFirstValidMenu(menu.children)
          if (found) return found
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f0f2f5;
}
.login-card {
  width: 400px;
  padding: 20px;
}
</style>